import { render, staticRenderFns } from "./yxzh.vue?vue&type=template&id=ac8693e4&scoped=true&"
var script = {}
import style0 from "./yxzh.vue?vue&type=style&index=0&id=ac8693e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8693e4",
  null
  
)

export default component.exports